import { CloseOutlined } from '@ant-design/icons';

import * as S from './styles';

export interface FilterChip {
  key: string;
  name: string;
  text: string;
  highlighted?: boolean;
  onRemove?: () => void;
}

interface Props {
  chips: FilterChip[];
}

export default function FilterChips({ chips }: Props) {
  return (
    <S.Chips role="group" aria-label="Filtros aplicados">
      {chips.map((chip) => (
        <S.Chip key={chip.key} data-highlighted={Boolean(chip.highlighted)}>
          <span>{chip.text}</span>
          {chip.onRemove && (
            <S.RemoveButton
              type="button"
              aria-label={`Remover filtro ${chip.name}`}
              onClick={chip.onRemove}
            >
              <CloseOutlined aria-hidden />
            </S.RemoveButton>
          )}
        </S.Chip>
      ))}
    </S.Chips>
  );
}
